import { Descriptions } from 'antd';
import styled from 'styled-components';

export const WorkDescriptions = styled(Descriptions)`
    width:80%;
    
`